import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import CallIcon from '@mui/icons-material/Call';

export const SidebarData = [
    {
        cName:'nav-text',
        path:'/dashboard',
        icon: <DashboardIcon />,
        title:'Dashboard',
        policy:'Dashboard'
    },
    {
        cName:'nav-text',
        path:'/utenti',
        icon: <PersonIcon />,
        title:'Utenti',
        policy:'Utenti'
    },
    {
        cName:'nav-text',
        path:'/dispositivi',
        icon: <PhoneAndroidIcon />,
        title:'Dispositivi',
        policy:'Dispositivi'
    },
    {
        cName:'nav-text',
        path:'/logs',
        icon: <CallIcon />,
        title:'Registro Chiamate',
        policy:'Chiamata'
    }
]